<article>
	<header>
		<h3>
			{{ 'adminstat.common.Billing errors' | translate }}
		</h3>
	</header>
	
	<section>
		<cache-date></cache-date>
	</section>
	
	<section>
		<period></period>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</section>
	
	<section>
		<chart
			[data]="paidErrorChart.data"
			[options]="paidErrorChart.options"
			[sextant]="'paidErrorChart'"
		></chart>
	</section>
	
	<section>
		<chart
			[data]="error3dsChart.data"
			[options]="error3dsChart.options"
			[sextant]="'error3dsChart'"
		></chart>
	</section>
	
	<section>
		<chart
			[data]="processingFilterChart.data"
			[options]="processingFilterChart.options"
			[sextant]="'processingFilterChart'"
		></chart>
	</section>
	
	<section>
		<chart
			[data]="noMoneyOrExpirerChart.data"
			[options]="noMoneyOrExpirerChart.options"
			[sextant]="'noMoneyOrExpirerChart'"
		></chart>
	</section>
	
	<section>
		<chart
			[data]="rejectEmitterChart.data"
			[options]="rejectEmitterChart.options"
			[sextant]="'rejectEmitterChart'"
		></chart>
	</section>
	
	<section>
		<chart
			[data]="unknownChart.data"
			[options]="unknownChart.options"
			[sextant]="'unknownChart'"
		></chart>
	</section>
	
	<section>
		<chart
			[data]="notClassifiedChart.data"
			[options]="notClassifiedChart.options"
			[sextant]="'notClassifiedChart'"
		></chart>
	</section>

	<section>
		<chart
				[data]="errSiteUserManualRecurentChart.data"
				[options]="errSiteUserManualRecurentChart.options"
				[sextant]="'errSiteUserManualRecurentChart'"
		></chart>
	</section>
	
	<section>
		<chart
			[data]="invalidCardDataChart.data"
			[options]="invalidCardDataChart.options"
			[sextant]="'invalidCardDataChart'"
		></chart>
	</section>
	
	<section>
		<br />

		<loading [isLoad]="listLoader"></loading>
		
		<ngb-pagination
			[collectionSize]="items.length"
			[pageSize]="pageSize"
			[maxSize]="10"
			[(page)]="page"
			[boundaryLinks]="true"
			(pageChange)="getPage()"
			[sextant]="'pagination'"
		></ngb-pagination>
	</section>
	
	<section>
		<table
			class="table table-striped table-bordered"
			[sextant]="'table'"
		>
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th colspan="2" style="text-align: center">{{ 'adminstat.billing.users with pay errors' | translate }}</th>
					<th colspan="2" style="text-align: center">{{ 'adminstat.billing.sites with pay errors' | translate }}</th>
				</tr>
				<tr>
					<th>{{ 'adminstat.common.Date' | translate }}</th>
					<th>Ручные</th>
					<th>Рекурентные</th>
					<th>Ручные</th>
					<th>Рекурентные</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let row of rows;">
					<td>
						{{ row.timestamp | dateFormat:'DD.MM.YYYY' }}
					</td>
					<td>
						<button-anhor (click)="showDetails(row.timestamp, 'users')">
							{{ row.userCountManual }}
						</button-anhor>
					</td>
					<td>
						<button-anhor (click)="showDetails(row.timestamp, 'users')">
							{{ row.userCountRecurent }}
						</button-anhor>
					</td>
					<td>
						<button-anhor (click)="showDetails(row.timestamp, 'sites')">
							{{ row.siteCountManual }}
						</button-anhor>
					</td>
					<td>
						<button-anhor (click)="showDetails(row.timestamp, 'sites')">
							{{ row.siteCountRecurent }}
						</button-anhor>
					</td>
				</tr>
			</tbody>
		</table>
	</section>
</article>
